<template>
	<div class="container">
		<p>筛选查询</p>
		<div class="container crumbs">
			<div class="handle-search ">
				<e-search :data="formData" :field-list="fieldList" :list-type-info="listTypeInfo" :btnStyle="btnStyle"
					@handleReset="handleClear" @handleFilter="handleQuery"></e-search>
			</div>
		</div>
		<p>日志列表</p>
		<div class="container crumbs">
			<TableList :loading="loading" :table-data="tableData" :table-label="tableLabel" @handleButton="handleButton"
				@handleSortChange="handleSortChange" @handleSelectionChange="handleSelectionChange"></TableList>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="page.pageNum"
					:page-sizes="[10, 20,50, 100, 200]" :page-size="page.pageSize" :total="pageTotal" prev-text="上一页" next-text="下一页"
					@current-change="handlePageChange" @size-change="handleSizeChange"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import ESearch from "../../components/common/e-search";
	import TableList from "../../components/common/e-table-list";
	import api from "../../api/logsystem/index";
	export default {
		//   name: "productCatalogExam",
		components: {
			ESearch,
			TableList
		},
		data() {
			return {
				loading: false,
				tableData: [],
				tableLabel: [{
						label: '协议编号',
						param: "code",
						align: 'center'
					},
					{
						label: "协议名称",
						param: "name",
						align: "center",
						width: "200"
					},
					{
						label: "供应商",
						param: "supplierCompanyName",
						align: "center"
					},
					{
						label: "操作类型",
						param: "operationType",
						align: "center",
						render: (row) => {
							if (row.operationType == "0") {
								return "协议新增"
							} else if (row.operationType == "1") {
								return "协议编辑"
							} else if (row.operationType == "2") {
								return "停用"
							} else if (row.operationType == "3") {
								return "启用"
							} else if (row.operationType == "4") {
								return "协议价调价"
							}
						}
					},
					{
						label: "操作人",
						param: "createName",
						align: "center"
					},
					{
						label: "操作时间",
						param: "mobile",
						align: "center"
					},
					{
						label: "IP地址",
						param: "memberIp",
						align: "center"
					},
				],
				//   tableOption: {
				//     label: "操作",
				//     width: "300",
				//     fixed: "right",
				//     options: [
				//       { label: "查看详情", type: "primary", methods: "handleOrderDetail" },
				//       { label: "查看并确认", type: "primary", methods: "handleOrderConfirm" },
				//      ],
				//     flag: true,
				//   },
				fieldList: [{
						label: '协议名称',
						type: 'input',
						value: 'name'
					},
					{
						label: '协议编号',
						type: 'input',
						value: 'cellPhoneNumber'
					},
					{
						label: '操作类型',
						type: 'select',
						value: 'supplierCompanyName',
						list: 'applicationStatus'
					},
					{
						label: '操作时间',
						type: 'date',
						value: 'startTime',
						dateType: 'daterange'
					},
					{
						label: '供应商',
						type: 'input',
						value: 'loginID'
					},
					{
						label: '操作人',
						type: 'input',
						value: 'emailAddress'
					},
					{
						label: 'IP地址',
						type: 'input',
						value: 'memberIp'
					}
				],
				listTypeInfo: {
					applicationStatus: [{
							id: "0",
							name: '协议新增'
						},
						{
							id: '1',
							name: '协议编辑'
						},
						{
							id: '2',
							name: '停用'
						},
						{
							id: '3',
							name: '启用'
						},
						{
							id: '4',
							name: '协议价调价'
						},
					],
				},
				btnStyle: [{
						icon: "el-icon-refresh",
						text: "重置"
					},
					{
						icon: "el-icon-search",
						text: "查询",
						type: "primary"
					},
				],
				pageTotal: 0,
				formData: {
					supplierCompanyName: '',
					startTime: '',
					endTime: '',
					applicationStatus: '',
					loginID: "",
					cellPhoneNumber: "",
					emailAddress: "",
					name: "",
					memberIp: ""
				},
				page: {
					pageNum: 1,
					pageSize: 10,
					logType: 4
				}
			}
		},
		created() {
			this.AccessAoThePaging()
		},
		methods: {
			// handleSearch() {
			//    this.formData.pageNum = 10
			//  },
			//重置
			handleClear() {
				this.AccessAoThePaging()
			},
			//查询
			handleQuery(val) {
				console.log(val)
				let Query = {
					code: val.cellPhoneNumber,
					name: val.name,
					// startTime:val.startTime[0],
					// endTime:val.startTime[1],
					// supplierCompanyName:val.emailAddress,
					// createName:val.emailAddress,
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					logType: this.page.logType,
					memberIp: val.memberIp
				}
				api.queryProductLogByPage(Query).then((res) => {
					this.tableData = res.data.records
					this.pageTotal = res.data.total
					console.log(res)
				})
			},
			// //
			// statusFormatter(row){
			//     let name =''
			//     this.listTypeInfo.applicationStatus.forEach(item=>{
			//         if(item.id==row.logType){
			//             console.log(item.id)
			//             name=item.name
			//         }
			//     })
			//     return name
			// },
			handleButton(val) {
				console.log(val)
			},
			handleSortChange() {},
			handleSelectionChange() {},
			//分页导航
			handlePageChange(val) {
				this.page.pageNum = val
				this.AccessAoThePaging()
			},
			handleSizeChange(pageSize) {
				console.log(pageSize)
				this.page.pageSize = pageSize
				this.AccessAoThePaging()
			},
			async AccessAoThePaging() {
				let res = await api.queryProductLogByPage(this.page)
				console.log(res)
				this.tableData = res.data.records
				this.pageTotal = res.data.total
			}
		}
	}
</script>

<style scoped lang="scss">
	.time {
		::v-deep .el-input {
			width: 80px;
		}
	}
</style>
